import React, { useEffect, useRef, useState } from 'react';
import { connect, useStore } from 'react-redux';
import useMedia from "use-media";
import commonUtil from '../../../common/commonUtil';
import { getFacilityInfo } from '../../../const';
import Const from '../../../const/Const';
import messageConst from '../../../const/messageConst';
import { GetPublicHoliday } from "../../../hooks/getPublicHoliday";
import "../../../resources/css/search/search.css";
import common from '../../../resources/js/common/common';
import { Button } from '../../atoms/button';
import { Label } from '../../atoms/label';
import { OptionPullDown } from '../../atoms/optionPullDown';
import { ErrorMassage } from '../../molecules/errorMassage';
import { ModalOptionForm } from '../../molecules/modalOptionForm';
import { PullDownOptionForm } from '../../molecules/pullDownOptionForm';
import CommonValidation from "../../../common/commonValidation";
import './../../../resources_membership_hotel/css/hotel/reserve.css';

const nights = [
    { id: "1", value: "1泊", selected: true },
    { id: "2", value: "2泊", selected: false },
    { id: "3", value: "3泊", selected: false },
    { id: "4", value: "4泊", selected: false },
    { id: "5", value: "5泊", selected: false },
    { id: "6", value: "6泊", selected: false }
];

const VacancyInfoCrawlContainer = (props) => {
    const {
        state,
        playDate1,
        room,
        checkIn,
        checkOut,
        setRoom,
        resvKaiinken,
        setResvKaiinken,
        grade,
        roomDetailCriteria,
        adultNum,
        dispAdultNum,
        setDispAdultNum,
        dispChildNum,
        setDispChildNum,
        roomNumber,
        setRoomNumber,
        childNum,
        setAdultNum,
        setChildNum,
        setCheckOut,
        setPlanConditions,
        setGrade,
        setRoomDetailCriteria,
        setFood,
        setPrivilegedService,
        setMembershipFacility,
        membershipFacility,
        onClickCheckIn,
        onClickOpenCheckListWindow,
        onClickOpenCrawlWindow,
        displaySwitch,
        setConditionChanged,
        runGetVacancyList,
        setDispFacility,
        setDispDetailCondition } = props;

    const { getHoliday } = GetPublicHoliday();

    const isMobilePhone = useMedia({ maxWidth: '480px' });
    const [mobilePhone, setMobilePhone] = useState(false);
    const [vacancyOverview, setVacancyOverview] = useState([]);
    const [vacancyList, setVacancyList] = useState([]);
    const [weekList, setWeekList] = useState([]);
    const [nextFlag, setNextFlag] = useState(false);
    const [NotSearch, setNotSearch] = useState(false);

    const [kaiinkenNumber, setKaiinkenNumber] = useState("1");
    const [nightsNumber, setNightsNumber] = useState("1");
    const [dispGrade, setDispGrade] = useState("選択なし");
    const [dispRoomDetailCriteria, setDispRoomDetailCriteria] = useState("選択なし");
    const checkInRef = useRef(checkIn);

    // エラー情報
    const [errorInfo, setErrorInfo] = useState({ errorMessage: null, errorFlg: false, });
    const [errFlgList, setErrFlgList] = useState({ errPeopleNum: false, errAdultNum: false });

    const store = useStore();

    // 会員権のデフォルト表示
    const defaultKaiinken = [{
        id: '',
        value: '会員を選択してください',
    }];

    useEffect(() => {
        if (isMobilePhone) {
            setMobilePhone(true);
        } else {
            setMobilePhone(false);
        }
    }, [isMobilePhone]);

    useEffect(() => {
        if (!state.calendarPopup) {
            let toString = Object.prototype.toString;
            let checkInClass = toString.call(checkInRef.current).slice(8, -1);
            if (checkInClass == "Date" && checkInRef.current.getTime() !== checkIn.getTime()) {
                const now = new Date();
                const limitDate = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate() + 1)
                let diff = (limitDate - checkIn) / 86400000;
                setNightsNumber("1");
                nights.forEach((data) => {
                    if (data.id === "1") {
                        data.selected = true;
                    } else {
                        data.selected = false;
                    }
                    if (data.id <= diff) {
                        data.disabled = false;
                    } else {
                        data.disabled = true;
                    }
                })
                // チェックアウト
                const checkOutDate = new Date(checkIn);
                checkOutDate.setDate(checkOutDate.getDate() + 1);
                setCheckOut(checkOutDate);
            }
        } else {
            checkInRef.current = new Date(checkIn);
        }
    }, [state.calendarPopup]);

    useEffect(() => {
        for (let i in room) {
            if (room[i].selected === true) {
                setRoomNumber(room[i].id);
            }
        }
        for (let i in adultNum) {
            if (adultNum[i].selected === true) {
                setDispAdultNum(adultNum[i].id);
            }
        }
        for (let i in childNum) {
            if (childNum[i].selected === true) {
                setDispChildNum(childNum[i].id);
            }
        }
        resvKaiinken.forEach((data) => {
            if (data.selected === true) setKaiinkenNumber(data.id);
        });
        setConditionChanged(true)
    }, [displaySwitch]);

    useEffect(() => {
        let toString = Object.prototype.toString;
        let checkInClass = toString.call(checkIn).slice(8, -1);
        let checkOutClass = toString.call(checkOut).slice(8, -1);
        let selectedNights = 1;
        if (checkInClass == "Date" && checkOutClass == "Date") {
            selectedNights = (checkOut - checkIn) / 86400000
            nights.forEach((data) => {
                if (Number(data.id) === selectedNights) {
                    data.selected = true;
                } else {
                    data.selected = false;
                }
            });
        }
        setNightsNumber(selectedNights);
    }, [checkIn, checkOut]);

    useEffect(() => {
        if (!state.checkListPopup && state.gradeFlg) {
            let dispText = "";
            grade.forEach(item => {
                if (item.checked) {
                    dispText = dispText + (!dispText ? "" : ", ");
                    dispText = dispText + item.value;
                }
            })
            if (dispText) {
                setDispGrade(dispText);
            } else {
                setDispGrade("選択なし");
            }
        }
        if (!state.checkListPopup && state.roomDetailCriteriaFlg) {
            let dispText = "";
            roomDetailCriteria.forEach(item => {
                if (item.checked) {
                    dispText = dispText + (!dispText ? "" : ", ");
                    dispText = dispText + item.value;
                }
            })
            setDispRoomDetailCriteria(dispText);
        }
    }, [state.checkListPopup]);


    // 検索ボタン押下時
    const onClickSearch = () => {
        let errorMessage = [];

        // 会員権
        let keiyakuNo = "";
        let kaiinkenCd = "";
        let kaiinkenNo = "";
        let riyoKaiinKenSbtKbn = "";
        resvKaiinken.forEach((data) => {
            if (data.selected === true) {
                keiyakuNo = data.keiyakuNo;
                kaiinkenCd = data.id;
                kaiinkenNo = data.value;
                riyoKaiinKenSbtKbn = data.riyoKaiinkenSyubetCd;
            }
        });

        // バリデーションフラグ
        let errFlg = false;
        let flgList = { errPeopleNum: false, errAdultNum: false };

        // 検索基準の日付を設定
        const checkInDate = new Date(checkIn);

        let y = checkInDate.getFullYear();
        let m = checkInDate.getMonth() + 1;
        let d = checkInDate.getDate();

        if (m < 10) m = `0${m}`
        if (d < 10) d = `0${d}`

        // チェックイン
        const startDate = commonUtil.getStringFromDate(checkInDate, "yyyy-MM-dd");

        // チェックアウト
        const checkOutDate = new Date(checkIn);
        checkOutDate.setDate(checkOutDate.getDate() + Number(nightsNumber));
        setCheckOut(checkOutDate);



        // 室数
        let vacancyNum = 1;
        room.forEach((data) => {
            if (data.selected === true) vacancyNum = parseInt(data.id);
        });

        // 1室あたりの人数
        let adults = 2;
        adultNum.forEach((data) => {
            if (data.selected === true) adults = parseInt(data.id);
        });
        let children = 0;
        childNum.forEach((data) => {
            if (data.selected === true) children = parseInt(data.id);
        });
        let guestCnt = adults + children;
        if (guestCnt > Const.MAX_ROOM_CAPACITY) {
            errorMessage.push(messageConst.PEOPLE_NUM_ERROR);
            errFlg = true;
            flgList.errPeopleNum = true;
        }
        // if (adults < vacancyNum) {
        //     errorMessage.push(messageConst.ADULT_NUM_ERROR);
        //     errFlg = true;
        //     flgList.errAdultNum = true;
        // }
        let req = {};
        let facilityArray = [];
        if (keiyakuNo) {
            // 施設
            membershipFacility.membership.forEach((data) => {
                if (data.shisetsuList) {
                    data.shisetsuList.forEach(item => {
                        if (item.checked) facilityArray.push(item.id);
                    })
                }
            });
            membershipFacility.ippan.forEach((data) => {
                if (data.shisetsuList) {
                    data.shisetsuList.forEach(item => {
                        if (item.checked) facilityArray.push(item.id);
                    })
                }
            });
            if (facilityArray.length === 0) {
                membershipFacility.membership.forEach((data) => {
                    if (data.shisetsuList) {
                        data.shisetsuList.forEach(item => {
                            if (!item.disabled) facilityArray.push(item.id);
                        })
                    }
                });
                membershipFacility.ippan.forEach((data) => {
                    if (data.shisetsuList) {
                        data.shisetsuList.forEach(item => {
                            if (!item.disabled) facilityArray.push(item.id);
                        })
                    }
                });
            }

            // グレード
            let gradeArray = [];
            grade.forEach((data) => {
                if (data.checked === true) gradeArray.push(data.id);
            });

            // 部屋詳細条件CD
            let roomConditionArray = [];
            roomDetailCriteria.forEach((data) => {
                if (data.checked === true) roomConditionArray.push(data.id);
            });

            req = {
                keiyakuNo: keiyakuNo,
                kaiinkenCd: kaiinkenCd,
                kaiinkenNo: kaiinkenNo,
                roomGradeList: gradeArray,
                startDate: startDate,
                nightsNumber: nightsNumber,
                shisetsuCdList: facilityArray,
                roomCnt: vacancyNum,
                guestCnt: guestCnt,
                adults: adults,
                children: children,
                riyoKaiinKenSbtKbn: riyoKaiinKenSbtKbn,
                crawlFlg: true,
                roomConditionCdList: roomConditionArray
            }
        } else {
            // 施設
            membershipFacility.membership.forEach((data) => {
                if (data.shisetsuList) {
                    data.shisetsuList.forEach(item => {
                        if (!item.disabled) facilityArray.push(item.id);
                    })
                }
            });
            membershipFacility.ippan.forEach((data) => {
                if (data.shisetsuList) {
                    data.shisetsuList.forEach(item => {
                        if (!item.disabled) facilityArray.push(item.id);
                    })
                }
            });
            // 部屋詳細条件CD
            let roomConditionArray = [];
            roomDetailCriteria.forEach((data) => {
                if (data.checked === true) roomConditionArray.push(data.id);
            });
            req = {
                keiyakuNo: Const.MASTER_CONTRACT_NO,
                roomGradeList: [],
                startDate: startDate,
                nightsNumber: nightsNumber,
                shisetsuCdList: facilityArray,
                roomCnt: vacancyNum,
                guestCnt: guestCnt,
                adults: adults,
                children: children,
                riyoKaiinKenSbtKbn: "1",
                crawlFlg: true,
                roomConditionCdList: roomConditionArray
            }
        }
        setErrFlgList(flgList);
        if (errFlg) {
            window.scroll({ top: 0, behavior: 'smooth' })
            setErrorInfo({ errorMessage: errorMessage, errorFlg: true, });
        } else {
            setErrorInfo({ errorMessage: null, errorFlg: false, });
            // カレンダー検索用検索情報取得
            runGetVacancyList(req, false);
        }
    }

    // チェックイン表示処理
    const getDateToString = () => {
        const youbi = ["日", "月", "火", "水", "木", "金", "土"];
        const checkInDate = new Date(checkIn);
        const y = checkInDate.getFullYear();
        const m = checkInDate.getMonth() + 1;
        const d = checkInDate.getDate();

        return `${y}年${m}月${d}日(${youbi[checkInDate.getDay()]})`;
    }

    // 施設表示
    const getFacility = () => {
        let dispText = store.getState().dispFacility ? store.getState().dispFacility : "選択なし";
        return dispText;
    }

    // // 詳細条件表示 グレード情報
    // const getDetailCriteria = () => {
    //     let dispText = store.getState().dispDetailCondition ? store.getState().dispDetailCondition : "選択なし";
    //     return dispText;
    // }

    //  部屋詳細条件表示
    const getRoomDetailCriteria = () => {
        let dispText = dispRoomDetailCriteria ? dispRoomDetailCriteria : "選択なし";
        return dispText;
    }

    // 選択した組数をstoreに保存
    const onChangeRoom = (e) => {
        setRoomNumber(e.target.value);

        room.forEach((data) => {
            if (data.id === e.target.value) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setRoom(room);
    };

    const onChangeKaiinkenName = (e) => {
        let keiyakuNo = "";
        setKaiinkenNumber(e.target.value);
        resvKaiinken.forEach((data) => {
            if (String(data.id) === e.target.value) {
                data.selected = true;
                keiyakuNo = data.keiyakuNo;
            } else {
                data.selected = false;
            }
        })
        setResvKaiinken(resvKaiinken);
        setDispFacility("選択なし");
        setDispGrade("選択なし");
        setDispRoomDetailCriteria("選択なし");
        // 施設・部屋グレード情報取得
        common.doPost(getFacilityInfo, { keiyakuNo: keiyakuNo }, afterGetFacilityInfo);
    }

    // 施設・部屋グレード情報取得後処理
    const afterGetFacilityInfo = (res) => {
        const data = res.data;
        if (data.resultCode == 0) {
            let memberHotelList = [];
            data.shisetsuInfo.memberHotelList.forEach(main => {
                let list = [];
                main.shisetsuList.forEach(membership => {
                    let membershipObj = { class: "facility", id: membership.shisetsuCd, value: membership.shisetsuName, checked: false, disabled: !membership.enable, openFlg: membership.openFlg, openingDate: membership.openingDate}
                    list.push(membershipObj);
                })
                let mainBuildingObj =
                {
                    mainGroupCd: main.mainGroupCd,
                    mainGroupName: main.mainGroupName,
                    checked: false,
                    displayFlg: false,
                    disabled: main.honkanShisetsuRiyoFlg,
                    shisetsuList: list
                };
                memberHotelList.push(mainBuildingObj);
            })

            let generalHotelList = [];
            data.shisetsuInfo.generalHotelList.forEach(main => {
                let list = [];
                main.shisetsuList.forEach(ippan => {
                    let ippanObj = { class: "facility", id: ippan.shisetsuCd, value: ippan.shisetsuName, checked: false, disabled: !ippan.enable }
                    list.push(ippanObj);
                })
                let mainBuildingObj =
                {
                    mainGroupCd: main.mainGroupCd,
                    mainGroupName: main.mainGroupName,
                    checked: false,
                    displayFlg: false,
                    disabled: false,
                    shisetsuList: list
                };
                generalHotelList.push(mainBuildingObj);
            })
            setMembershipFacility({ membership: memberHotelList, ippan: generalHotelList });

            let grades = [];
            data.roomGradeList.forEach(value => {
                let item = { class: "gradeList", id: value.gradeCd, value: value.gradeName, checked: false, disabled: !value.enable }
                grades.push(item);
            })
            setGrade(grades);

            let planConditionsList = [];
            data.planConditionsList.forEach(value => {
                let item = { class: "planConditions", id: value.planConditionsCd, value: value.planConditionsName, checked: false, disabled: !value.enable }
                planConditionsList.push(item);
            })
            setPlanConditions(planConditionsList);

            let foodList = [];
            data.foodList.forEach(value => {
                let item = { class: "foodList", id: value.foodCd, value: value.foodName, checked: false, disabled: !value.enable }
                foodList.push(item);
            })
            setFood(foodList);

            let privilegedServiceList = [];
            data.privilegedServiceList.forEach(value => {
                let item = { class: "privilegedService", id: value.privilegedServiceCd, value: value.privilegedServiceName, checked: false, disabled: false, description: value.privilegedServiceText }
                privilegedServiceList.push(item);
            })
            setPrivilegedService(privilegedServiceList);

            let roomDetailCriterias = [];
            data.roomConditionsList.forEach(value => {
                let item = { class: "gradeList", id: value.roomConditionCd, value: value.roomConditionName, checked: false }
                roomDetailCriterias.push(item);
            })
            setRoomDetailCriteria(roomDetailCriterias);
        }
    }

    // 選択した組数をstoreに保存
    const onChangeAdultNum = (e) => {
        setDispAdultNum(e.target.value);
        const selected = e.target.value;
        adultNum.forEach((data) => {
            if (data.id === selected) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setAdultNum(adultNum);
    };
    // 選択した組数をstoreに保存
    const onChangeChildNum = (e) => {
        setDispChildNum(e.target.value);
        const selected = e.target.value;
        childNum.forEach((data) => {
            if (data.id === selected) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        setChildNum(childNum);
    };

    // 選択した組数をstoreに保存
    const onChangeNigths = (e) => {
        const selected = e.target.value;
        setNightsNumber(selected);
        nights.forEach((data) => {
            if (data.id === selected) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        const checkOutDate = new Date(checkIn);
        checkOutDate.setDate(checkOutDate.getDate() + Number(selected));
        setCheckOut(checkOutDate);
    };


    return (
        <div style={style.container}>
            <div style={errorInfo.errorFlg ? style.errorDiv : { display: "none" }}>
                <ErrorMassage style={style.errorMassage} data={errorInfo.errorMessage} />
            </div>
            <div style={isMobilePhone ? style.vacancy__title2 : style.vacancy__title}>
                {isMobilePhone ? (<>
                    <h5>空室情報から探す</h5>
                </>) : (<>
                    <h3>空室情報から探す</h3>
                </>)}
            </div>
            <div style={style.searchConditions}>
                <div style={NotSearch ? { display: "block", color: "red", textAlign: "center", fontSize: "0.8rem", background: "rgba(255,255,255,0)", border: 0, fontWeight: "bold" } : { display: "none" }} > 検索に失敗しました</div>
                <div style={style.search}>
                    <PullDownOptionForm
                        id="kaiinkenVacancy"
                        divClass={isMobilePhone ? "wrapMobile kaiinkenMobile" : "wrap kaiinkenCalendar"}
                        title={"会員権選択"}
                        selectClass="pullDownOptionKaiinkenStyle"
                        labelClassName="modalLabel"
                        data={resvKaiinken.length ? resvKaiinken : defaultKaiinken}
                        state={kaiinkenNumber}
                        onChange={onChangeKaiinkenName}
                        disabled={resvKaiinken && resvKaiinken.length ? false : true}
                    />
                    <button className="magnifyingGlassCalendar" onClick={() => onClickOpenCrawlWindow("")}></button>
                    <ModalOptionForm
                        id={"grade"}
                        divClass={isMobilePhone ? "wrapMobile" : "wrap"}
                        title={"グレード※"}
                        onClick={resvKaiinken.length ? onClickOpenCheckListWindow : null}
                        text={resvKaiinken.length ? dispGrade : '会員を選択してください'}
                        dateClass={resvKaiinken.length ? "" : "disabledClass"}
                    />
                    <ModalOptionForm
                        id={"roomDetailCriteria"}
                        divClass={isMobilePhone ? "wrapMobile" : "wrap"}
                        title={"部屋詳細条件"}
                        onClick={onClickOpenCheckListWindow}
                        text={getRoomDetailCriteria()}
                    />
                    <ModalOptionForm
                        id={"checkIn"}
                        divClass={isMobilePhone ? "wrapMobile" : "wrap"}
                        title={"チェックイン"}
                        onClick={onClickCheckIn}
                        text={getDateToString()} />
                    <ModalOptionForm
                        id={"facility"}
                        divClass={isMobilePhone ? "wrapMobile" : "wrap"}
                        title={"ホテル"}
                        onClick={resvKaiinken.length ? onClickOpenCheckListWindow : null}
                        text={resvKaiinken.length ? getFacility() : '会員を選択してください'}
                        dateClass={resvKaiinken.length ? "" : "disabledClass"}
                    />
                    <PullDownOptionForm
                        divClass={mobilePhone ? "wrapMobile" : "wrap"}
                        title={"室数"}
                        selectClass="pullDownOptionStyle"
                        labelClassName="modalLabel"
                        data={room}
                        state={roomNumber}
                        onChange={onChangeRoom}
                    />
                    <div className={isMobilePhone ? "wrapMobile" : "wrap"}>
                        <Label className={"membershipModalLabel"} label={isMobilePhone ? "1室あたり利用人数\n（小学生未満の人数は入力不要）" : "1室あたり利用人数（小学生未満の人数は入力不要）"} />
                        <div className={isMobilePhone ? "" : "humanInput"}>
                            <div className={isMobilePhone ? "humanPullDownSp" : "humanPullDown"}>
                                <Label className={"modalLabel"} label="大人" />
                                <OptionPullDown
                                    data={adultNum}
                                    selectClass={errFlgList.errPeopleNum || errFlgList.errAdultNum ? "humanPullDownOptionStyleErr" : "humanPullDownOptionStyle"}
                                    onChange={onChangeAdultNum}
                                    value={dispAdultNum}
                                    id="adultNum" />
                            </div>
                            <div className={isMobilePhone ? "humanPullDownSp" : "humanPullDown"}>
                                <Label className={"modalLabel"} label="小学生" />
                                <OptionPullDown
                                    data={childNum}
                                    selectClass={errFlgList.errPeopleNum ? "humanPullDownOptionStyleErr" : "humanPullDownOptionStyle"}
                                    onChange={onChangeChildNum}
                                    value={dispChildNum}
                                    id="childNum" />
                            </div>
                        </div>
                    </div>
                    <PullDownOptionForm
                        divClass={mobilePhone ? "wrapMobile" : "wrap"}
                        id="nights"
                        title={"泊数"}
                        selectClass="pullDownOptionStyle"
                        labelClassName="modalLabel"
                        data={nights}
                        state={nightsNumber}
                        onChange={onChangeNigths}
                    />
                </div>
                <div style={isMobilePhone ? style.searchboxMobile : style.searchbox}>
                    <Label label={messageConst.CRAWL_SEARCH_INFO} style={style.errorDiv} />
                    <Button buttonText="検 索" className={mobilePhone ? "searchBtnStyleSp" : "searchBtnStylePc"} onClick={onClickSearch} />
                </div>
                <div style={isMobilePhone ? style.notesAreaMobile : style.notesArea}>
                    <Label label="※サンメンバーズとザ・ロッジの客室タイプは、すべてが「スタンダード」タイプです。" />
                </div>
            </div>
        </div>
    );
}

const style = {
    container: {
        marginRight: "auto",
        marginLeft: "auto",
    },
    vacancy__title: {
        fontWeight: "bold",
        textAlign: "left",
        marginBottom: "20px",
        height: "25px",
    },
    vacancy__title2: {
        fontWeight: "bold",
        textAlign: "left",
        display: 'flex',
        paddingTop: "5px",
    },
    searchConditions: {
        width: "100%",
    },
    searchbox: {
        width: "100%",
        padding: "10px 0px 20px 0px",
        margin: "10px auto"
    },
    searchboxMobile: {
        width: "100%",
        padding: "10px 0px 0px 0px",
        margin: "10px auto"
    },
    notesArea: {
        textAlign: "left",
        color: "rgb(170, 170, 170)",
    },
    notesAreaMobile: {
        padding: "10px 0",
        textAlign: "left",
        color: "rgb(170, 170, 170)",
        fontSize: "small",
    },
    search: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
    },
    monthStyle: {
        fontWeight: "bold",
        fontSize: "1.5rem",
        marginLeft: "5px",
    },
    monthStyleMobile: {
        fontWeight: "bold",
        fontSize: "1rem",
        marginLeft: "5px",
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "center",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
}

const mapStateToProps = (state) => {
    return {
        playDate1: state.playDate1,
        room: state.room,
        resvKaiinken: state.resvKaiinken,
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        grade: state.grade,
        roomDetailCriteria: state.roomDetailCriteria,
        membershipFacility: state.membershipFacility,
        adultNum: state.adultNum,
        childNum: state.childNum,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setResvKaiinken: (item) => {
            dispatch({ type: "RESV_KAIINKEN", payload: { resvKaiinken: item } })
        },
        setGrade: (item) => {
            dispatch({ type: "GRADE", payload: { grade: item } })
        },
        setRoomDetailCriteria: (item) => {
            dispatch({ type: "ROOM_DETAIL_CRITERIA", payload: { roomDetailCriteria: item } })
        },
        setPlanConditions: (item) => {
            dispatch({ type: "PLAN_CONDITIONS", payload: { planConditions: item } })
        },
        setPrivilegedService: (item) => {
            dispatch({ type: "PRIVILEGED_SERVICE", payload: { privilegedService: item } })
        },
        setFood: (item) => {
            dispatch({ type: "FOOD", payload: { food: item } })
        },
        setMembershipFacility: (item) => {
            dispatch({ type: "MEMBERSHIP_FACILITY", payload: { membershipFacility: item } })
        },
        setCheckOut: (item) => {
            dispatch({ type: "CHECKOUT", payload: { checkOut: item } })
        },
        setAdultNum: (item) => {
            dispatch({ type: "ADULT_NUM", payload: { adultNum: item } })
        },
        setChildNum: (item) => {
            dispatch({ type: "CHILD_NUM", payload: { childNum: item } })
        },
        setDispFacility: (item) => {
            dispatch({ type: "DISP_FACILITY", payload: { dispFacility: item } })
        },
        setDispDetailCondition: (item) => {
            dispatch({ type: "DISP_DETAIL_CONDITION", payload: { dispDetailCondition: item } })
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VacancyInfoCrawlContainer);
